import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee);

import { take, put } from 'redux-saga/effects';
import network from '../../../network/network';
import { workingStart, workingEnd } from '../../working/actions';
import * as actions from '../actions';
export default function _callee() {
  var _yield$take, payload, _yield$take$payload, _yield$take$payload$i, authenticationViewBeans, authenticationViewBean, showInterdictionContent, submitInterdictionURL, postSuccessAction, postSuccessPayload, response, InterdictionViewBean;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 44;
            break;
          }

          _context.next = 3;
          return take(actions.INTERDICTION_START);

        case 3:
          _yield$take = _context.sent;
          payload = _yield$take.payload;
          _yield$take$payload = _yield$take.payload;
          _yield$take$payload$i = _yield$take$payload.interdiction;
          authenticationViewBeans = _yield$take$payload$i.authenticationViewBeans;
          authenticationViewBean = _yield$take$payload$i.authenticationViewBean;
          showInterdictionContent = _yield$take$payload$i.showInterdictionContent;
          submitInterdictionURL = _yield$take$payload$i.submitInterdictionURL;
          postSuccessAction = _yield$take$payload.postSuccessAction;
          postSuccessPayload = _yield$take$payload.postSuccessPayload;
          _context.next = 15;
          return put(workingStart());

        case 15:
          if (!(authenticationViewBean || authenticationViewBeans)) {
            _context.next = 22;
            break;
          }

          _context.next = 18;
          return put(workingEnd());

        case 18:
          _context.next = 20;
          return put(actions.initInterdiction(payload));

        case 20:
          _context.next = 42;
          break;

        case 22:
          if (!showInterdictionContent) {
            _context.next = 42;
            break;
          }

          _context.prev = 23;
          _context.next = 26;
          return network().get({
            url: submitInterdictionURL,
            includeRootContext: false
          });

        case 26:
          response = _context.sent;

          if (!response.showInterdictionContent) {
            _context.next = 32;
            break;
          }

          _context.next = 30;
          return put(workingEnd());

        case 30:
          _context.next = 32;
          return put(actions.initInterdiction({
            interdiction: response,
            postSuccessAction: postSuccessAction,
            postSuccessPayload: postSuccessPayload
          }));

        case 32:
          _context.next = 42;
          break;

        case 34:
          _context.prev = 34;
          _context.t0 = _context["catch"](23);
          // This is called if the response from the new request has the root "InterdictionViewBean" object
          // and is captured & rejected by the interdiction filter
          InterdictionViewBean = _context.t0.InterdictionViewBean;
          _context.next = 39;
          return put(workingEnd());

        case 39:
          if (!InterdictionViewBean) {
            _context.next = 42;
            break;
          }

          _context.next = 42;
          return put(actions.initInterdiction({
            interdiction: InterdictionViewBean,
            postSuccessAction: postSuccessAction,
            postSuccessPayload: postSuccessPayload
          }));

        case 42:
          _context.next = 0;
          break;

        case 44:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[23, 34]]);
}